import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import useWindowSize from "react-use/esm/useWindowSize";
import Confetti from "react-confetti";
import { useNavigate, useParams } from "react-router";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchStats } from "../_redux/order/orderAction";
import RefreshIcon from "@mui/icons-material/Refresh";
import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles((theme) => ({
  refreshIcon: {
    transition: "transform 0.3s linear",
    animation: "$rotate 1s linear infinite",
  },
  "@keyframes rotate": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));
export const SuccessfulOrder = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { statsData, role } = useSelector(
    (state) => ({
      statsData: state.order.statsData,
      role: state.auth.user.roles,
    }),
    shallowEqual
  );
  useEffect(() => {
    if (role && role?.length && role[0] === "super-admin") {
      dispatch(fetchStats());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const handleRefreshClick = () => {
    dispatch(fetchStats());
    // setRotating(true);
  };
  const { width, height } = useWindowSize();
  return (
    <>
      <div className="text-center successful-order">
        <Confetti width={width} height={height} numberOfPieces={50} />
        <CheckCircleIcon />
        <h1>Congratulations!</h1>
        <p>You are all set. Well done!</p>
        <div className="d-flex justify-content-center mb-6">
          <button
            //   type="reset"
            className="btn btn-dark font-weight-bolder font-size-sm mr-3 "
            onClick={() => navigate("/new-order-stripe")}
          >
            New Order
          </button>
          <button
            type="submit"
            className="btn btn-primary font-weight-bolder font-size-sm "
            onClick={() =>
              navigate(`/order-details/${id}`)
            }
          >
            View Order
          </button>
        </div>
      </div>
      {role && role?.length && role[0] === "super-admin" && (
        <div className="col-lg-12">
          <hr />
          <div className="row orderTableCard p-2" style={{ fontSize: "13px" }}>
            <div className="col-lg-2 col-md-6  d-flex  ">
              Collections Yesterday:&nbsp;
              <strong>{statsData?.collectionsYesterday || "-"}</strong>
            </div>
            <div className="col-lg-2 col-md-6  d-flex  ">
              Collections Today:&nbsp;
              <strong>{statsData?.collectionsToday || "-"}</strong>
            </div>

            <div className="col-lg-2 col-md-6  d-flex  ">
              Collection Last Month:&nbsp;
              <strong>{statsData?.collectionsPreviousMonth || "-"}</strong>
            </div>
            <div className="col-lg-2 col-md-6  d-flex  ">
              Collection This Month:&nbsp;
              <strong>{statsData?.collectionsThisMonth || "-"}</strong>
            </div>
            <div className="col-lg-4 col-md-12  d-flex    justify-content-between">
              <span>
                Time Elapsed Since Last Order (HH:MM):&nbsp;
                <strong>{statsData?.elapsedTime || "-"}</strong>
              </span>
              <div onClick={handleRefreshClick} style={{ cursor: "pointer" }}>
                <RefreshIcon
                  className={` ${statsData?.loading ? classes.refreshIcon : ""
                    }`}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
